import React from "react";
import { Col, Row } from "react-bootstrap";
import Brand from "../assets/images/logo.png";
import Check from "../assets/images/check.svg";
import Vector from "../assets/images/vectorLogin.svg";
import Pattern from "../assets/images/pattern.svg";
import shapeEnd from "../assets/images/shapeQuoteEnd.svg";
import { Link } from "react-router-dom";
import ForgotPasswordForm from "../components/login/ForgotPasswordForm";
const ForgetPassword = () => {
  return (
    <div className="mainLogin">
      <Row className="g-0">
        <Col lg={6} className="d-lg-block d-none">
          <div className="quotoWrapper">
            <img src={Vector} alt="" className="vectorImg" />
            <div className="brandName">
              <img src={Brand} height="60" alt="" />
            </div>
            <div className="quote">
              <span className="q-mark">“</span>
              <p>
                The passage experienced a surge in popularity during the 1960s
                when Letraset used it on their dry-transfer sheets, and again
                during the 90s as desktop publishers bundled the text with their
                software.
              </p>
              <div className="name">
                Vincent Obi{" "}
                <i>
                  <img src={Check} alt="" />
                </i>
              </div>
              <div className="quoteFooter">
                <img src={Pattern} alt="" />
                <img src={shapeEnd} alt="" />
              </div>
            </div>

            <div className="copyrights">
              &copy; 2022 Copyrights, the product, All rights reserved
            </div>
          </div>
        </Col>
        <Col lg={6}>
          <div className="contentLogin">
            <div className="text-end">
              <p>
                Problem signing in? <Link to="#">Contact us!</Link>
              </p>
            </div>
            <ForgotPasswordForm />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgetPassword;
